import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { Container, Row, Col, Card, CardBody, Label, Button, Spinner } from 'reactstrap'
import { currencyFormatter } from '../../../utils/currencyFormatter'
import AddDraftContract from '../../../components/Modal/AddDraftContract'
import AddContract from '../../../components/Modal/AddContract'
import DataTable from '../../../components/Template/Table/DataTable'
import Select from '../../../components/Template/Input/Select'
import Breadcrumbs from '../../../components/Common/Breadcrumb'
import { listProposals, listBids, getContracts, getLegalEntities } from '../../../store/ducks/comercial'
import { history } from '../../../store'
import graphRequest from '../../../utils/graphRequest/index'
import oikosApi from '../../../services/oikos'
import moment from 'moment'
import qs from 'qs'
import { MaterialReactTable } from 'material-react-table'
import AddContract2 from '../../../components/Modal/AddContract2'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs'

class Contracts extends Component {
  constructor(props) {
    super(props)
    this.state = {
      clientTypeFilter: [
        {
          value: 'Privado',
          label: 'Privado',
        },
        {
          value: 'Público',
          label: 'Público',
        },
      ],
      statusFilter: null,
      addContractModalIsOpen: false,
      addContractData: {},
      addDraftContractModalIsOpen: false,
      addDraftContractPreviousData: {},
      getDataIsLoading: false,
      data: false,
      data_contratos_vigentes: false,
      data_contratos_nao_vigentes: false,
      contractDetails: {},
      loadingRows: [],
    }
  }

  componentDidMount() {
    const { getContracts, listProposals, listBids, getLegalEntities } = this.props

    this.preloading();

  }

  preloading = async () => {
    getLegalEntities()
    getContracts()
    listProposals()
    listBids()
    this.getData()
  }

  getData = async () => {
    this.setState({ getDataIsLoading: true })
    try {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      var aux_join
      let aux_minutas = await oikosApi.get('/', {
        table: 'minuta',
        action: 'get',
      })
      let aux_contratos = await oikosApi.get(`/?${qs.stringify({
        table: 'contrato',
        action: 'get',
        order_field: 'contrato_dtAssin',
        order_dir: 'DESC',
        data: {
          'contrato_ativo': 1,
          'contrato_cadastro': 1,
        },
        fields: {
          '(SELECT areaAtua_id FROM pj WHERE pj.pj_id = contrato.contrato_contratante)': 'areaAtua_id',
          '(SELECT proj_id FROM proj WHERE proj.contrato_id = contrato.contrato_id AND proj.proj_ativo = 1)': 'proj_id',
          '(SELECT proj_id FROM proj WHERE proj.contrato_id = contrato.contrato_original AND proj.proj_ativo = 1)': 'proj_id_contrato_original',
          '(SELECT pj_nomefanta FROM pj WHERE pj.pj_id = contrato.contrato_contratante)': 'pj_nomefanta',
          '(SELECT contratoInst_desc FROM contratoInst WHERE contratoInst.contratoInst_id = contrato.contratoInst_id)': 'contratoInst_desc',
          '(SELECT contratoAlterTp_desc FROM contratoAlterTp WHERE contratoAlterTp.contratoAlterTp_id = contrato.contratoAlterTp_id)': 'contratoAlterTp_desc',
          '(SELECT areaAtua_id FROM pj WHERE pj.pj_id = contrato.contrato_contratante)': 'areaAtua_id',
          '(SELECT pj_emailPrin FROM pj WHERE pj.pj_id = contrato.contrato_contratante)': 'pj_emailPrin',
          '(SELECT areaAtua_area FROM areaAtua WHERE areaAtua_id = (SELECT areaAtua_id FROM pj WHERE pj.pj_id = contrato.contrato_contratante))': 'areaAtua_area',
          '(SELECT arquivo_caminho FROM arquivo WHERE arquivo.arquivo_tabRef = "documento" AND arquivo.arquivo_ativo = 1 AND arquivo.arquivo_tabId = (SELECT documento_id FROM documentoVinc WHERE documentoVinc.documentoVinc_tabRef = "contrato" AND documentoVinc.documentoVinc_tabId = contrato.contrato_id AND (SELECT tpDocumento_id FROM documento WHERE documento.documento_id = documentoVinc.documento_id) = 6 ORDER BY documento_id DESC LIMIT 1) LIMIT 1)': 'arquivo_caminho'
        }
      })}`)
      const allContracts = aux_contratos.data;
      const isAditivo = c => !!c.contrato_original || !!c.contrato_prazoVigenciaOrig || c.contratoInst_id > 1;
      const parentContracts = allContracts.filter(c => !isAditivo(c));
      const aditivos = allContracts.filter(isAditivo);

      parentContracts.forEach(parent => {
        parent.aditivos = aditivos.filter(a => a.contrato_original === parent.contrato_id).map(a => ({ ...a, parentPdf: parent.arquivo_caminho }));
        parent.contrato_vlrConsolidado = (Number(parent.contrato_vlrGlobal) || 0) + parent.aditivos.reduce((sum, a) => sum + (Number(a.contrato_vlrGlobal) || 0), 0);

        let maxVigencia = parent.contrato_prazoVigencia ? new Date(parent.contrato_prazoVigencia).getTime() : 0;
        let maxVigenciaDate = parent.contrato_prazoVigencia;
        parent.aditivos.forEach(a => {
          if (a.contrato_prazoVigencia) {
            const vig = new Date(a.contrato_prazoVigencia).getTime();
            if (vig > maxVigencia) {
              maxVigencia = vig;
              maxVigenciaDate = a.contrato_prazoVigencia;
            }
          }
        });
        parent.contrato_vigenciaConsolidada = maxVigenciaDate;
      });

      let aux_contratos_vigentes = parentContracts.filter(el => {
        const date = new Date(el.contrato_vigenciaConsolidada || el.contrato_prazoVigencia)
        return date >= today;
      })
      let aux_contratos_nao_vigentes = parentContracts.filter(el => {
        const date = new Date(el.contrato_vigenciaConsolidada || el.contrato_prazoVigencia)
        return date < today;
      })
      let aux_contratos_emcontratacao = await oikosApi.get(`/?${qs.stringify({
        table: 'contrato',
        action: 'get',
        order_field: 'contrato_dtAssin',
        order_dir: 'DESC',
        data: {
          'contrato_ativo': 1,
          'contrato_projAbert': 0,
        },
        fields: {
          '(SELECT proj_id FROM proj WHERE proj.contrato_id = contrato.contrato_id AND proj.proj_ativo = 1)': 'proj_id',
          '(SELECT proj_id FROM proj WHERE proj.contrato_id = contrato.contrato_original AND proj.proj_ativo = 1)': 'proj_id_contrato_original',
          '(SELECT pj_nomefanta FROM pj WHERE pj.pj_id = contrato.contrato_contratante)': 'pj_nomefanta',
          '(SELECT contratoInst_desc FROM contratoInst WHERE contratoInst.contratoInst_id = contrato.contratoInst_id)': 'contratoInst_desc',
          '(SELECT contratoAlterTp_desc FROM contratoAlterTp WHERE contratoAlterTp.contratoAlterTp_id = contrato.contratoAlterTp_id)': 'contratoAlterTp_desc',
          '(SELECT areaAtua_id FROM pj WHERE pj.pj_id = contrato.contrato_contratante)': 'areaAtua_id',
          '(SELECT pj_emailPrin FROM pj WHERE pj.pj_id = contrato.contrato_contratante)': 'pj_emailPrin',
          '(SELECT areaAtua_area FROM areaAtua WHERE areaAtua_id = (SELECT areaAtua_id FROM pj WHERE pj.pj_id = contrato.contrato_contratante))': 'areaAtua_area',
          '(SELECT prop_id FROM prop WHERE prop.bitrix_id = contrato.oport_id AND prop.prop_ativo = 1 AND prop.propStatus_id = 5 LIMIT 1)': 'prop_id'
        }
      })}`)
      /*
            var siteId = 'ecossissolucoes.sharepoint.com,e13a07f6-096a-45ee-8dfa-74f532b19a7f,ab4a25d0-22db-487b-a5b6-4da8e59bd13c'
            var listId = '24e2b5f2-3b68-40f3-96a8-d154f82986d1'
            var pars = `expand=fields(select=id,Title,w7nx,Status0,Status,Valor,Setores,zlir,N_x00fa_meroSEGI,Cliente,Aditivo)&top=9999&filter=fields/Status0 eq 'Em contratação'`
            const data_private = await graphRequest(siteId, listId, pars)
            console.log('data_private = ', data_private)
            aux_join = data_private.map(el => ({'SPId':el.id,'origem':'privado','datacontratada':moment(el.zlir).format('DD/MM/YYYY'),'cliente':el.Cliente,'nome':el.Title,'status':el.Status0,'minuta_id':aux_minutas.findLast(x => x.minuta_SPId === parseInt(el.id))?.minuta_id,'minuta_status':aux_minutas.findLast(x => x.minuta_SPId === parseInt(el.id))?.minuta_status,'contrato_id':aux_contratos.find(x => x.minuta_id === aux_minutas.findLast(x => x.minuta_SPId === parseInt(el.id))?.minuta_id)?.contrato_id,
          'valor': isNaN(el.Valor) ? "-" : currencyFormatter.format(el.Valor),
          'minuta_contratada': aux_minutas.findLast(x => x.minuta_SPId === parseInt(el.id))?.minuta_contratada,
          'minuta_contratadaAssina': aux_minutas.findLast(x => x.minuta_SPId === parseInt(el.id))?.minuta_contratadaAssina,
          'minuta_contratante': aux_minutas.findLast(x => x.minuta_SPId === parseInt(el.id))?.minuta_contratante,
          'codigo':el.N_x00fa_meroSEGI,
          'minuta_aditivo':(el.Aditivo=="Sim") ? 1 : 0,
          }))
            console.log('aux_join = ', aux_join)
            var siteId = 'ecossissolucoes.sharepoint.com,e13a07f6-096a-45ee-8dfa-74f532b19a7f,32cf4926-8ed5-475c-918f-6b48d3e42b49'
            var listId = 'df3f359b-f817-44b5-a140-e384223bf177'
            var pars = `top=9999&expand=fields&$filter=(fields/Vencedor eq 'ECOSSIS SOLUCOES AMBIENTAIS S/S LTDA') AND ((fields/Situa_x00e7__x00e3_o eq 'Homologado') OR (fields/Situa_x00e7__x00e3_o eq 'Declarado vencedor'))`
            const data_public = await graphRequest(siteId, listId, pars)
            console.log('minuta_id = ', aux_minutas.findLast(x => x.minuta_SPId === 385)?.minuta_id)
            console.log('data_public = ', data_public)
            aux_join = aux_join.concat(data_public.map(el => ({'SPId':el.id,'origem':'publico','datacontratada':moment(el.Abertura).format('DD/MM/YYYY'),'cliente':el.Unidadelicitante,'nome':el.Objeto,'status':el.Situa_x00e7__x00e3_o,'minuta_id':aux_minutas.findLast(x => x.minuta_SPId === parseInt(el.id))?.minuta_id,'minuta_status':aux_minutas.findLast(x => x.minuta_SPId === parseInt(el.id))?.minuta_status,
            'valor': isNaN(el.Lance_x0020_Vencedor) ? "-" : currencyFormatter.format(el.Lance_x0020_Vencedor),
            'minuta_contratada': aux_minutas.findLast(x => x.minuta_SPId === parseInt(el.id))?.minuta_contratada,
            'minuta_contratadaAssina': aux_minutas.findLast(x => x.minuta_SPId === parseInt(el.id))?.minuta_contratadaAssina,
            'minuta_contratante': aux_minutas.findLast(x => x.minuta_SPId === parseInt(el.id))?.minuta_contratante,
            'codigo':el.Title,
            'minuta_aditivo':(el.Aditivo=="Sim") ? 1 : 0,
          })))
            console.log('aux_join = ', aux_join)
      */
      const em_contrato_data = aux_contratos_emcontratacao.data ? aux_contratos_emcontratacao.data.filter(c => !isAditivo(c) || Number(c.contrato_cadastro) === 0) : [];
      this.setState({ getDataIsLoading: false, data: em_contrato_data, data_contratos_vigentes: aux_contratos_vigentes, data_contratos_nao_vigentes: aux_contratos_nao_vigentes })
    } catch (err) {
      this.setState({ getDataIsLoading: false, data: false, contratos: false })
      console.tron.log('Não foi possível carregar a série de dados a partir do SharePoint.', err)
    }
  }

  renderActionsButton = (item) => {
    console.log(item)
    let status = item.proj_id === null ? 0 : 1
    switch (status) {
      case 0: return (
        <>
          <Button
            color="info"
            size="sm"
            outline
            onClick={() => {
              console.log(item)
            }}
          >
            Aguardando cadastro
          </Button>
        </>
      )

      case 1: return (
        <Button
          color="primary"
          size="sm"
          outline
          onClick={() => this.setState({
            addContractModalIsOpen: true,
            addContractData: item,
          })}
        >
          Em cadastramento
        </Button>
      )

    }
  }

  handleRowExpand = async (row) => {
    const contractId = row.original.contrato_id;
    // Fetch detailed data for this row
    try {
      const res = await oikosApi.get(
        `/?${qs.stringify({
          action: "get",
          table: "contrato",
          data: {
            contrato_original: contractId,
            contrato_ativo: 1,
          },
          fields: {
            '(SELECT arquivo_caminho FROM arquivo WHERE arquivo.arquivo_tabRef = "documento" AND arquivo.arquivo_ativo = 1 AND arquivo.arquivo_tabId = (SELECT documento_id FROM documentoVinc WHERE documentoVinc.documentoVinc_tabRef = "contrato" AND documentoVinc.documentoVinc_tabId = contrato.contrato_id AND (SELECT tpDocumento_id FROM documento WHERE documento.documento_id = documentoVinc.documento_id) = 6 ORDER BY documento_id DESC LIMIT 1) LIMIT 1)': 'arquivo_caminho'
          }
        })}`
      );

      // Store the fetched details in state
      this.setState((prevState) => ({
        contractDetails: {
          ...prevState.contractDetails,
          [row.id]: res.data,
        },
      }));
    } catch (error) {
      console.error("Failed to fetch product details:", error);
    }
  };

  // Id | Criação | Código | Objeto | Cliente | Ações
  render() {
    const {
      getContractsData, getContractsIsLoading,
      bids, listBidsIsLoading,
      proposals, listProposalsIsLoading,
      legalEntities, getLegalEntitiesIsLoading
    } = this.props.comercial

    //const { isManager } = this.props.auth.user

    const {
      clientTypeFilter,
      addContractModalIsOpen, addContractData, addDraftContractModalIsOpen, addDraftContractPreviousData, data, data_contratos_vigentes, data_contratos_nao_vigentes,
    } = this.state

    /*
                        <DataTable
                          className="table-clickable"
                          data={{
                            columns: [
                              {
                                label: 'Data assinatura',
                                field: 'contrato_dtAssin',
                                sort: 'desc',
                              },
                              {
                                label: 'Setor',
                                field: 'clientType',
                                sort: 'desc',
                              },
                              {
                                label: 'Número',
                                field: 'number',
                                sort: 'desc',
                              },
                              // {
                              //   label: 'Nome',
                              //   field: 'name',
                              //   sort: 'desc',
                              // },
                              {
                                label: 'Cliente',
                                field: 'client',
                                sort: 'desc',
                              },
                              {
                                label: 'Valor',
                                field: 'value',
                                sort: 'desc',
                              },
                              {
                                label: 'Vigência',
                                field: 'contrato_prazoVigencia',
                                sort: 'desc',
                              },
                              // {
                              //   label: 'Status',
                              //   field: 'status',
                              //   sort: 'desc',
                              // },
                            ],
                            rows: data_contratos?.map(contract => ({
                              contrato_dtAssin: moment(contract.contrato_dtAssin).format('DD/MM/YYYY'),
                              clientType: contract.clientType,
                              number: contract.contrato_num,
                              client: legalEntities?.find(l => l.pj_id === contract.contrato_contratante)?.pj_nomefanta,
                              value: currencyFormatter.format(contract.contrato_vlrGlobal),
                              contrato_prazoVigencia: moment(contract.contrato_prazoVigencia).format('DD/MM/YYYY'),
                              clickEvent: () => (
                                history.push({
                                  pathname: `/comercial/contratos/${contract.contrato_id}`,
                                })
                              ),
                            })),
                          }}
                        />
                        */

    const columns = [
      {
        accessorKey: 'contrato_id',
        header: 'ID',
        size: 100,
      },
      {
        accessorKey: 'contrato_dtAssin',
        header: 'Data',
        size: 100,
        accessorFn: (row) => {
          if (row.contrato_dtAssin) {
            return moment(row.contrato_dtAssin, 'YYYY-MM-DD').toDate();
          } else {
            return null;
          }
        },
        sortingFn: 'datetime',
        Cell: ({ cell, row }) => {
          if (row.original.contrato_dtAssin) {
            return moment(cell.getValue()).format('DD/MM/YYYY')
          }
        }, // Format Date for display
      },
      {
        accessorKey: 'pj_nomefanta',
        header: 'Cliente',
        accessorFn: (row) => row.pj_nomefanta,
        size: 300,
        sortingFn: 'alphanumeric',
        Cell: ({ cell, row }) => {
          return (cell.getValue())
        }
      },
      {
        accessorKey: 'contrato_obj',
        header: 'Objeto',
        size: 400,
        accessorFn: (row) => row.contrato_obj,
        sortingFn: 'alphanumeric',
        Cell: ({ cell, row }) => {
          return (cell.getValue())
        }
      },
      {
        accessorKey: 'contrato_vlrGlobal',
        header: 'Valor',
        size: 100,
        accessorFn: (row) => row.contrato_vlrGlobal,
        sortingFn: 'alphanumeric',
        Cell: ({ cell, row }) => {
          if (row.original.contrato_vlrGlobal) {
            return currencyFormatter.format(cell.getValue())
          }
        }
      },
      {
        accessorKey: 'contratoInst_id',
        header: 'Alteração contratual',
        size: 100,
        accessorFn: (row) => row.contratoInst_id,
        sortingFn: 'alphanumeric',
        Cell: ({ cell, row }) => {
          if (row.original.contratoInst_id) {
            return row.original.contratoInst_desc
          }
        }
      },
      {
        header: 'Ação',
        size: 100,
        accessorFn: (row) => {
          if (Number(row.contrato_cadastro) === 0) {
            return <AddContract2 preloading={this.preloading} addContractDataDraft={row} data={{ products: [], paymentEvents: [], data: row }} />
          }
          return <span>Aguardando abertura</span>
        }
      },
    ]

    const columnsContratosAssinados = [
      {
        accessorKey: 'pj_nomefanta',
        header: 'Cliente',
        size: 30,
        sortingFn: 'alphanumeric',
        filterVariant: 'text',
        filterFn: 'includesString',
      },
      {
        accessorKey: 'areaAtua_area',
        header: 'Setor',
        size: 30,
      },
      {
        accessorKey: 'oportOrig_id',
        header: 'Origem',
        accessorFn: (row) => {
          if (row.oportOrig_id) {
            switch (row.oportOrig_id) {
              case 1:
                return "Público"
              case 2:
                return "Privado"
            }
          }
        },
        size: 50,
        sortingFn: 'alphanumeric',
        Cell: ({ cell, row }) => {
          if (row.original.oportOrig_id) {
            switch (row.original.oportOrig_id) {
              case 1:
                return "Público"
              case 2:
                return "Privado"
            }
          }
        },
        filterSelectOptions: [
          'Público',
          'Privado',
        ],
        filterVariant: 'multi-select'
      },
      {
        accessorKey: 'contrato_num',
        header: 'Número',
        size: 30,
      },
      {
        accessorKey: 'contrato_vlrConsolidado',
        header: 'Valor',
        accessorFn: (row) => row.contrato_vlrConsolidado,
        size: 50,
        sortingFn: 'alphanumeric',
        Cell: ({ cell, row }) => {
          if (row.original.contrato_vlrConsolidado !== undefined && row.original.contrato_vlrConsolidado !== null) {
            return currencyFormatter.format(cell.getValue())
          }
        },
        filterVariant: 'range',
        filterFn: 'valorRangeFilterFn',
      },
      {
        accessorKey: 'contrato_dtAssin',
        header: 'Data de assinatura',
        accessorFn: (row) => {
          if (row.contrato_dtAssin) {
            return (new Date(row.contrato_dtAssin)).getTime();
          } else {
            return null;
          }
        },
        size: 30,
        Cell: ({ cell, row }) => {
          if (row.original.contrato_dtAssin) {
            return moment(row.original.contrato_dtAssin).format('DD/MM/YYYY')
          }
        }, // Format Date for display
        filterVariant: 'range',
        filterFn: 'dateRangeFilterFn',
        sortingFn: 'datetime',
      },
      {
        accessorKey: 'contrato_vigenciaConsolidada',
        header: 'Vigência',
        size: 30,
        accessorFn: (row) => {
          if (row.contrato_vigenciaConsolidada) {
            return moment(row.contrato_vigenciaConsolidada, 'YYYY-MM-DD').toDate();
          } else {
            return null;
          }
        },
        Cell: ({ cell, row }) => {
          if (row.original.contrato_vigenciaConsolidada) {
            return moment(cell.getValue()).format('DD/MM/YYYY')
          }
        }, // Format Date for display
        filterVariant: 'range',
        filterFn: 'dateRangeFilterFn',
        sortingFn: 'datetime',
      },
      {
        accessorKey: 'arquivo_caminho',
        header: 'Link PDF',
        size: 30,
        Cell: ({ cell, row }) => {
          if (row.original.arquivo_caminho) {
            return <Button size="sm" color="info" onClick={(e) => { e.stopPropagation(); window.open(`https://oikos.ecoss.is/oikos/${row.original.arquivo_caminho}`, '_blank'); }}>PDF</Button>
          }
          return null
        },
      },
    ]

    const columnsAditivos = [
      {
        accessorKey: 'contratoInst_id',
        header: 'Tipo',
        accessorFn: (row) => {
          switch (row.contratoInst_id) {
            case 1:
              return "Contrato"
            case 2:
              return "Aditamento"
            case 4:
              return "Apostilamento"
            case 3:
              return "Renovação"
            case 5:
              return "Rescisão"
          }
        },
        size: 50,
        filterSelectOptions: [
          'Contrato',
          'Rescisão',
          'Renovação',
          'Apostilamento',
          'Aditamento',
        ],
        filterVariant: 'multi-select'
      },

      {
        accessorKey: 'contrato_dtAssin',
        header: 'Data assinatura',
        accessorFn: (row) => {
          if (row.contrato_dtAssin) {
            return (new Date(row.contrato_dtAssin)).getTime();
          } else {
            return null;
          }
        },
        size: 30,
        Cell: ({ cell, row }) => {
          if (row.original.contrato_dtAssin) {
            return moment(row.original.contrato_dtAssin).format('DD/MM/YYYY')
          }
        }, // Format Date for display
        filterVariant: 'range',
        filterFn: 'dateRangeFilterFn',
        sortingFn: 'datetime',
      },
      {
        accessorKey: 'contrato_dtIniVig',
        header: 'Início vigência',
        accessorFn: (row) => {
          if (row.contrato_dtIniVig) {
            return (new Date(row.contrato_dtIniVig)).getTime();
          } else {
            return null;
          }
        },
        size: 30,
        Cell: ({ cell, row }) => {
          if (row.original.contrato_dtIniVig) {
            return moment(row.original.contrato_dtIniVig).format('DD/MM/YYYY')
          }
        }, // Format Date for display
        filterVariant: 'range',
        filterFn: 'dateRangeFilterFn',
        sortingFn: 'datetime',
      },
      {
        accessorKey: 'contrato_vlrGlobal',
        header: 'Valor',
        accessorFn: (row) => row.contrato_vlrGlobal,
        size: 50,
        sortingFn: 'alphanumeric',
        Cell: ({ cell, row }) => {
          if (row.original.contrato_vlrGlobal !== null && row.original.contrato_vlrGlobal !== undefined) {
            return currencyFormatter.format(cell.getValue())
          }
        },
        filterVariant: 'range',
        filterFn: 'valorRangeFilterFn',
      },
      {
        accessorKey: 'contrato_obj',
        header: 'Objeto',
        size: 300,
        Cell: ({ cell }) => (
          <div style={{ whiteSpace: 'normal', minWidth: '300px' }}>
            {cell.getValue()}
          </div>
        )
      },
      {
        accessorKey: 'contrato_prazoExecucao',
        header: 'Prazo execução',
        accessorFn: (row) => {
          if (row.contrato_prazoExecucao) {
            return moment(row.contrato_prazoExecucao, 'YYYY-MM-DD').toDate();
          } else {
            return null;
          }
        },
        size: 30,
        Cell: ({ cell, row }) => {
          if (row.original.contrato_prazoExecucao) {
            return moment(cell.getValue()).format('DD/MM/YYYY')
          }
        }, // Format Date for display
        sortingFn: 'datetime',
      },
      {
        accessorKey: 'contrato_prazoVigencia',
        header: 'Vigência',
        size: 30,
        accessorFn: (row) => {
          if (row.contrato_prazoVigencia) {
            return moment(row.contrato_prazoVigencia, 'YYYY-MM-DD').toDate();
          } else {
            return null;
          }
        },
        Cell: ({ cell, row }) => {
          if (row.original.contrato_prazoVigencia) {
            return moment(cell.getValue()).format('DD/MM/YYYY')
          }
        }, // Format Date for display
        filterVariant: 'range',
        filterFn: 'dateRangeFilterFn',
        sortingFn: 'datetime',
      },
      {
        accessorKey: 'arquivo_caminho',
        header: 'Link PDF',
        size: 30,
        Cell: ({ cell, row }) => {
          if (row.original.arquivo_caminho) {
            return <Button size="sm" color="info" onClick={(e) => { e.stopPropagation(); window.open(`https://oikos.ecoss.is/oikos/${row.original.arquivo_caminho}`, '_blank'); }}>PDF</Button>
          }
          return null
        }, // Format Date for display
      },
    ]

    //if (!isManager) return <Redirect to="/" />

    if (this.state.getDataIsLoading) {
      return <Spinner style={{ marginTop: "50vh", marginLeft: "50vw" }} />
    }

    if (data) {
      return (
        <div className="page-content">
          <AddContract
            isOpen={addContractModalIsOpen}
            addContractDataDraft={addContractData}
            addContractData={addContractData}
            contractId={addContractData.contrato_id}
            toggle={() => {
              this.setState({
                addContractModalIsOpen: false,
                addContractData: {},
              })

              this.componentDidMount()
            }}
          />

          <Container fluid>
            <Breadcrumbs
              title="Contratos"
              breadcrumbItems={[]}
            />

            <Row className="mt-3 mb-3">
              <Col>
                <h4>
                  Em cadastramento
                </h4>
              </Col>
            </Row>
            <Row>
              <Col>
                <MaterialReactTable
                  columns={columns}
                  data={data}
                  initialState={{
                    density: 'compact',
                    expanded: {}, //expand all groups by default
                    pagination: { pageIndex: 0, pageSize: 50 },
                    sorting: [{ id: 'contrato_dtAssin', desc: true }],
                  }}
                  enableGrouping={false}
                  enableGlobalFilter={true}
                  enableFilters={true}
                  enablePagination={(data.length > 50)}
                  muiTopToolbarProps={{
                    sx: {
                      '.MuiBox-root': { marginTop: "10px", height: "20px", display: "flex", alignItems: "center" },
                      '.MuiSvgIcon-root': { width: '12px' },
                      '.MuiButtonBase-root': { padding: '5px 5px 5px 5px' },
                      '.MuiTablePagination-root .MuiToolbar-root': { minHeight: "30px !important", height: "30px !important" },
                      '.MuiTablePagination-root': { minHeight: "30px !important", height: "30px !important", marginTop: "2.3rem" },
                    }
                  }}

                  muiTableBodyCellProps={{ sx: { fontSize: "13px", whiteSpace: 'normal', overflowWrap: 'break-word', maxWidth: "300px" } }}

                  muiTablePaginationProps={{
                    sx: { '.MuiTablePagination-displayedRows': { fontSize: "12px" }, fontSize: "12px" },
                    labelRowsPerPage: <span style={{ fontSize: "12px" }}>Projetos por página</span>,
                    rowsPerPageOptions: [50, 100],
                  }}
                  positionPagination='bottom'
                  muiTableHeadCellColumnActionsButtonProps={{ size: "8px" }}
                  enableRowExpansion={true}
                  enableDensityToggle={false}
                  enableColumnFilters={false}
                  muiTableHeadCellProps={{
                    sx: {
                      fontSize: '12px',
                      fontWeight: 'normal', // Remove bold text in the header
                      padding: '8px', // Adjust padding to reduce white space
                    },
                  }}
                />
                {/*<Card>
                  <CardBody>
                    <DataTable
                      data={{
                        columns: [
                          {
                            label: 'Data',
                            field: 'date',
                            sort: 'desc',
                          },
                          {
                            label: 'Cliente',
                            field: 'client',
                            sort: 'desc',
                          },
                          {
                            label: 'Número',
                            field: 'num',
                            sort: 'desc',
                          },
                          {
                            label: 'Nome',
                            field: 'title',
                            sort: 'desc',
                          },
                          {
                            label: 'Objeto',
                            field: 'obj',
                            sort: 'desc',
                          },
                          {
                            label: 'Valor',
                            field: 'value',
                            sort: 'desc',
                          },
                          {
                            label: 'Aditivo',
                            field: 'aditivo',
                            sort: 'desc',
                          },
                          {
                            label: 'Ações',
                            field: 'actions',
                            sort: 'disabled',
                          },
                        ],
                        rows: data.map(item => ({
                          date: moment(item.contrato_dtAssin).format("DD/MM/YYYY"),
                          client: item.contrato_contratante,
                          num: item.contrato_num,
                          title: item.contrato_nome,
                          obj: item.contrato_obj,
                          client: legalEntities?.find(l => l.pj_id === item.contrato_contratante)?.pj_nomefanta,
                          value: currencyFormatter.format(item.contrato_vlrGlobal),
                          aditivo: item.contratoInst_id > 1 ? "Sim" : "Não",
                          actions: this.renderActionsButton(item),
                        })),
                      }}
                    />
                  </CardBody>
                </Card>*/}
              </Col>
            </Row>

            <Row className="mt-3 mb-3">
              <Col>
                <h4>
                  Contratos Cadastrados
                </h4>
              </Col>
            </Row>

            <Tabs>
              <TabList>
                <Tab>{`Vigentes (${data_contratos_vigentes.length})`}</Tab>
                <Tab>{`Não vigentes (${data_contratos_nao_vigentes.length})`}</Tab>
              </TabList>
              <TabPanel>
                <Row>
                  <Col>
                    <MaterialReactTable
                      columns={columnsContratosAssinados}
                      data={data_contratos_vigentes}
                      initialState={{
                        density: 'compact',
                        expanded: {}, //expand all groups by default
                        pagination: { pageIndex: 0, pageSize: 50 },
                        sorting: [{ id: 'contrato_dtAssin', desc: true }],
                      }}
                      enableFacetedValues
                      enableGrouping
                      enableGlobalFilter={true}
                      enableFilters={true}
                      enablePagination={(data_contratos_vigentes.length > 50)}
                      muiTopToolbarProps={{
                        sx: {
                          '.MuiBox-root': { marginTop: "10px", height: "20px", display: "flex", alignItems: "center" },
                          '.MuiSvgIcon-root': { width: '12px' },
                          '.MuiButtonBase-root': { padding: '5px 5px 5px 5px' },
                          '.MuiTablePagination-root .MuiToolbar-root': { minHeight: "30px !important", height: "30px !important" },
                          '.MuiTablePagination-root': { minHeight: "30px !important", height: "30px !important", marginTop: "2.3rem" },
                        }
                      }}

                      muiTableBodyCellProps={{ sx: { fontSize: "13px", maxWidth: "100px" } }}
                      muiTablePaginationProps={{
                        sx: { '.MuiTablePagination-displayedRows': { fontSize: "12px" }, fontSize: "12px" },
                        labelRowsPerPage: <span style={{ fontSize: "12px" }}>Projetos por página</span>,
                        rowsPerPageOptions: [50, 100],
                      }}
                      filterFns={{
                        dateRangeFilterFn: (row, id, filterValue) => {

                          if (!filterValue || !filterValue[0] || !filterValue[1]) {
                            return true; // Return true to show all rows if the filter is cleared
                          }

                          return ((row.getValue(id) >= (new Date(filterValue[0])).getTime()) && (row.getValue(id) <= (new Date(filterValue[1])).getTime()))
                        },
                        valorRangeFilterFn: (row, id, filterValue) => {

                          if (!filterValue || !filterValue[0] || !filterValue[1]) {
                            return true; // Return true to show all rows if the filter is cleared
                          }

                          return ((row.getValue(id) >= (filterValue[0])) && (row.getValue(id) <= (filterValue[1])))
                        },
                      }}
                      positionPagination='bottom'
                      muiTableHeadCellColumnActionsButtonProps={{ size: "8px" }}
                      enableRowExpansion={true}
                      enableDensityToggle={false}
                      enableColumnFilters={true}
                      muiTableHeadCellProps={{
                        sx: {
                          fontSize: '12px',
                          fontWeight: 'normal', // Remove bold text in the header
                          padding: '8px', // Adjust padding to reduce white space
                        },
                      }}

                      muiTableBodyRowProps={({ row }) => ({
                        onClick: () => (
                          history.push({
                            pathname: `/comercial/contratos/${row.original.contrato_id}`,
                          })
                        ),
                        sx: { cursor: 'pointer' },
                      })}
                      renderDetailPanel={({ row }) => {
                        const details = row.original.aditivos || [];

                        if (details.length === 0) {
                          return <div style={{ padding: '10px', textAlign: 'center' }}>Este contrato não possui aditivos.</div>;
                        }

                        return (
                          <MaterialReactTable
                            columns={columnsAditivos}
                            data={details}
                            initialState={{
                              density: 'compact',
                              expanded: {}, //expand all groups by default
                              pagination: { pageIndex: 0, pageSize: 50 },
                              sorting: [], //sort by state by default
                            }}
                            enableGrouping={false}
                            enableTopToolbar={false}
                            enableGlobalFilter={true}
                            enableFilters={true}
                            muiTablePaperProps={{ sx: { boxShadow: 'none' } }}
                            enablePagination={(details.length > 50)}
                            muiTopToolbarProps={{ sx: { '.MuiBox-root': { marginTop: "10px", height: "20px", display: "flex", alignItems: "center" }, '.MuiSvgIcon-root': { width: '12px' }, '.MuiButtonBase-root': { padding: '5px 5px 5px 5px' } } }}
                            muiTableBodyCellProps={{ sx: { fontSize: "13px" } }}
                            muiTablePaginationProps={{
                              sx: { '.MuiTablePagination-displayedRows': { fontSize: "12px" }, marginTop: "0px", fontSize: "12px" },
                              labelRowsPerPage: <span style={{ fontSize: "12px" }}>Registros por página</span>,
                              rowsPerPageOptions: [50, 100],
                            }}
                            positionPagination='top'
                            muiTableHeadCellColumnActionsButtonProps={{ size: "8px" }}
                            enableRowExpansion={false}
                            enableDensityToggle={false}
                            enableColumnFilters={false}
                            muiTableHeadCellProps={{
                              sx: {
                                '.MuiSvgIcon-root': { fontSize: "18px" },
                                fontSize: '12px',
                                fontWeight: 'normal', // Remove bold text in the header
                                padding: '8px', // Adjust padding to reduce white space
                              },
                            }}
                          />
                        )
                      }}
                    />
                  </Col>
                </Row>
              </TabPanel>
              <TabPanel>
                <Row>
                  <Col>
                    <MaterialReactTable
                      columns={columnsContratosAssinados}
                      data={data_contratos_nao_vigentes}
                      initialState={{
                        density: 'compact',
                        expanded: {}, //expand all groups by default
                        pagination: { pageIndex: 0, pageSize: 50 },
                        sorting: [{ id: 'contrato_dtAssin', desc: true }],
                      }}
                      enableFacetedValues
                      enableGrouping
                      enableGlobalFilter={true}
                      enableFilters={true}
                      enablePagination={(data_contratos_nao_vigentes.length > 50)}
                      muiTopToolbarProps={{
                        sx: {
                          '.MuiBox-root': { marginTop: "10px", height: "20px", display: "flex", alignItems: "center" },
                          '.MuiSvgIcon-root': { width: '12px' },
                          '.MuiButtonBase-root': { padding: '5px 5px 5px 5px' },
                          '.MuiTablePagination-root .MuiToolbar-root': { minHeight: "30px !important", height: "30px !important" },
                          '.MuiTablePagination-root': { minHeight: "30px !important", height: "30px !important", marginTop: "2.3rem" },
                        }
                      }}

                      muiTableBodyCellProps={{ sx: { fontSize: "13px", maxWidth: "100px" } }}
                      muiTablePaginationProps={{
                        sx: { '.MuiTablePagination-displayedRows': { fontSize: "12px" }, fontSize: "12px" },
                        labelRowsPerPage: <span style={{ fontSize: "12px" }}>Projetos por página</span>,
                        rowsPerPageOptions: [50, 100],
                      }}
                      filterFns={{
                        dateRangeFilterFn: (row, id, filterValue) => {

                          if (!filterValue || !filterValue[0] || !filterValue[1]) {
                            return true; // Return true to show all rows if the filter is cleared
                          }

                          return ((row.getValue(id) >= (new Date(filterValue[0])).getTime()) && (row.getValue(id) <= (new Date(filterValue[1])).getTime()))
                        },
                        valorRangeFilterFn: (row, id, filterValue) => {

                          if (!filterValue || !filterValue[0] || !filterValue[1]) {
                            return true; // Return true to show all rows if the filter is cleared
                          }

                          return ((row.getValue(id) >= (filterValue[0])) && (row.getValue(id) <= (filterValue[1])))
                        },
                      }}
                      positionPagination='bottom'
                      muiTableHeadCellColumnActionsButtonProps={{ size: "8px" }}
                      enableRowExpansion={true}
                      enableDensityToggle={false}
                      enableColumnFilters={true}
                      muiTableHeadCellProps={{
                        sx: {
                          fontSize: '12px',
                          fontWeight: 'normal', // Remove bold text in the header
                          padding: '8px', // Adjust padding to reduce white space
                        },
                      }}

                      muiTableBodyRowProps={({ row }) => ({
                        onClick: () => (
                          history.push({
                            pathname: `/comercial/contratos/${row.original.contrato_id}`,
                          })
                        ),
                        sx: { cursor: 'pointer' },
                      })}
                      renderDetailPanel={({ row }) => {
                        const details = row.original.aditivos || [];

                        if (details.length === 0) {
                          return <div style={{ padding: '10px', textAlign: 'center' }}>Este contrato não possui aditivos.</div>;
                        }

                        return (
                          <MaterialReactTable
                            columns={columnsAditivos}
                            data={details}
                            initialState={{
                              density: 'compact',
                              expanded: {}, //expand all groups by default
                              pagination: { pageIndex: 0, pageSize: 50 },
                              sorting: [], //sort by state by default
                            }}
                            enableGrouping={false}
                            enableTopToolbar={false}
                            enableGlobalFilter={true}
                            enableFilters={true}
                            muiTablePaperProps={{ sx: { boxShadow: 'none' } }}
                            enablePagination={(details.length > 50)}
                            muiTopToolbarProps={{ sx: { '.MuiBox-root': { marginTop: "10px", height: "20px", display: "flex", alignItems: "center" }, '.MuiSvgIcon-root': { width: '12px' }, '.MuiButtonBase-root': { padding: '5px 5px 5px 5px' } } }}
                            muiTableBodyCellProps={{ sx: { fontSize: "13px" } }}
                            muiTablePaginationProps={{
                              sx: { '.MuiTablePagination-displayedRows': { fontSize: "12px" }, marginTop: "0px", fontSize: "12px" },
                              labelRowsPerPage: <span style={{ fontSize: "12px" }}>Registros por página</span>,
                              rowsPerPageOptions: [50, 100],
                            }}
                            positionPagination='top'
                            muiTableHeadCellColumnActionsButtonProps={{ size: "8px" }}
                            enableRowExpansion={false}
                            enableDensityToggle={false}
                            enableColumnFilters={false}
                            muiTableHeadCellProps={{
                              sx: {
                                '.MuiSvgIcon-root': { fontSize: "18px" },
                                fontSize: '12px',
                                fontWeight: 'normal', // Remove bold text in the header
                                padding: '8px', // Adjust padding to reduce white space
                              },
                            }}
                          />
                        )
                      }}
                    />
                  </Col>
                </Row>
              </TabPanel>
            </Tabs>



          </Container>
        </div>
      )
    }

    return null
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
  comercial: state.comercial,
})
const mapDispatchToProps = dispatch => bindActionCreators({
  getContracts,
  listProposals,
  listBids,
  getLegalEntities,
}, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(Contracts)
